import React from 'react'
import { View } from 'react-native'
import Constants from 'expo-constants'
import tw from 'tailwind-rn'

import { HGText } from '../HGUI'
import * as v from '../../config/variables'
import { getVersion } from '../../lib/utils'

const isNotProduction =
  process.env.MODE !== 'PRODUCTION' &&
  Constants.manifest.releaseChannel !== 'production'

const VersionInfo = (): React.ReactElement => {
  const versionTextStyle = tw('text-sm text-gray-500')
  const versionString = getVersion()

  return (
    <View style={tw('items-center justify-center mt-6 mb-3')}>
      <HGText style={[versionTextStyle, { fontFamily: v.FONT_FAMILY_BOLD }]}>
        Hans & Gretel
      </HGText>
      {/* <HGText style={versionTextStyle }>Version { VersionNumber.appVersion } ({ VersionNumber.buildVersion })</HGText> */}
      <HGText style={versionTextStyle}>Version {versionString}</HGText>

      {isNotProduction && (
        <HGText style={versionTextStyle}>Expo v{Constants.expoVersion}</HGText>
      )}

      {isNotProduction && (
        <HGText style={versionTextStyle}>
          {(
            Constants.manifest.releaseChannel || process.env.MODE
          )?.toUpperCase()}
        </HGText>
      )}
    </View>
  )
}

export default VersionInfo
